<app-card-actions heading="Profile" (close)="close()"></app-card-actions>
<div class="wrapper" mat-dialog-content>
  
  <div class="profile">
    <div class="inner">
      <div class="left">
        <app-avatar [user]="user" [large]="true" (clicked)="editPhoto()" [preview]="preview" [canEdit]="true"></app-avatar>
      </div>
      <div class="right">
         
        <div class="rank">Leaderboard Rank: <b>#{{rank}}</b><mat-icon>star</mat-icon> </div>

        <div class="data">
          <div class="name">{{ user?.name }}</div>
          <div class="roles">
            <div *ngFor="let role of user?.roles;">
              <div class="role-badge">
                {{role}}
              </div>
            </div>
          </div>
          <div class="email">{{ user?.email }}</div>
          <br>
          <div class="tenant" *ngIf="tenantService.currentTenant$ | async as tenant" (click)="selectTenant()">

            <span class="label">Organization:</span>
            {{ tenant.company }}
            <mat-icon class="tenant-icon">arrow_drop_down</mat-icon>
          </div>
          <mat-card class="stats">
            <mat-card-content>
              <div>Cards Worked on: {{ user?.cardCount }}</div>
              <br>
              <div>Average Score: {{ user?.averageScore | number: '1.2-2' }}</div>
            </mat-card-content>
          </mat-card>
        </div>
      </div>
    </div>
  </div>

  <br>

  <!-- Theme Selector Section -->
  <div class="theme-section">
    <div class="section-title">
      <mat-icon>palette</mat-icon>
      <span>Theme Settings</span>
    </div>
    <div class="theme-options">
      <div
        *ngFor="let theme of themeService.availableThemes"
        class="theme-option"
        [class.active]="(themeService.currentTheme$ | async) === theme.value"
      >
        <div class="theme-header" (click)="selectTheme(theme.value)">
          <div class="theme-preview" [class]="theme.value + '-preview'">
            <mat-icon>{{ theme.icon }}</mat-icon>
          </div>
          <div class="theme-details">
            <div class="theme-label">{{ theme.label }}</div>
            <div class="theme-description">{{ theme.description }}</div>
          </div>
          <mat-icon class="check-icon" *ngIf="(themeService.currentTheme$ | async) === theme.value">check_circle</mat-icon>
        </div>

        <!-- Background Options -->
        <div class="background-options">
          <div class="background-label">Background:</div>
          <div class="background-previews">
            <div
              *ngFor="let bg of getBackgroundOptions(theme.value)"
              class="background-preview"
              [class.selected]="isBackgroundSelected(theme.value, bg.variant)"
              [style.background]="bg.previewGradient"
              [title]="bg.name"
              (click)="selectBackground(theme.value, bg.variant)"
            >
              <mat-icon class="bg-check-icon" *ngIf="isBackgroundSelected(theme.value, bg.variant)">check</mat-icon>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div mat-dialog-actions class="buttons" align="end">
    <button mat-button mat-raised-button extended color="warn" (click)="logout()">
      <mat-icon>logout</mat-icon> Logout
    </button>
  </div>
</div>